import {  Grid} from "@material-ui/core";
import React from "react";
import { BuscadorProveedor } from "./BuscadorProveedor";
import {TabsProveedores} from "./TabsProveedores"

/*const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
    marginTop: "1rem",
    borderRadius: 5,
  },
}));*/

export const ProveedoresConsulta = (props) => {
    const {Menu} = props;
    // const {proveedorInfo} = useSelector((state) => state.proveedores)
    // const isDisabled = proveedorInfo.idProveedor === null;
    // const [value, setValue] = useState("1");

    

    // const handleChange = (event, newValue) => (
    //   setValue(newValue)
    // )

    // useEffect(() => {
    //   setValue("1")
    // }, [proveedorInfo])
    // console.log(proveedorInfo.idProveedor)
    return (
      <>
        <Grid container justify="center">
          <Grid item xs={4} style={{marginBottom: "100px", marginTop: "25px"}} alignContent={'center'}>
            <BuscadorProveedor />
          </Grid>

          { 
            // proveedorInfo &&
            <TabsProveedores Menu={Menu} />
        //     <Grid className={classes.root}>
        //     <TabContext value={value}>
        //     <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        //       <TabList onChange={handleChange}>
        //         <Tab label="Información" value="1" />
        //         <Tab label="Datos Contacto" value="2" disabled={isDisabled} />
        //         <Tab label="Datos Contables" value="3" />
        //         <Tab label="Documentación" value="4" />
        //       </TabList>
        //     </Box>

        //     <TabPanel value="1" >
        //       <InformacionProveedor />
        //     </TabPanel>
        //     <TabPanel value="2" >
        //       <DatosContactoProveedor />
        //     </TabPanel>
        //     <TabPanel value="3">
        //       <DatosContablesProveedor />
        //     </TabPanel>
        //     <TabPanel value="4">
        //       <DocumentacionProveedor />
        //     </TabPanel>
        //   </TabContext>
        // </Grid>
          }
          

          {/* <Grid item xs={12} >
            {
              proveedorInfo &&
              <TabGeneric
              tabs={[
                {
                  title: "Información",
                  body: <InformacionProveedor  />, 
                },
                {
                  title: "Datos Contacto",
                  body: <DatosContactoProveedor />,
                },
                {
                  title: "Datos Contables",
                  body: <DatosContablesProveedor />
                },
                {
                  title: "Documentación",
                  body: <DocumentacionProveedor />
                }
              ]}
            />
            }
            
          </Grid> */}
        </Grid>
      </>
    );
}

export default ProveedoresConsulta;